import React, { useEffect, useRef, useState } from 'react';

function getCSRFToken() {
  const m = document.cookie.match(/(^|;\s*)csrftoken=([^;]+)/);
  return m ? decodeURIComponent(m[2]) : '';
}

const PayphoneBox = ({ txId, amountInCents, items }) => {
  const iframeRef = useRef(null);
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    fetch('/ecommerce/api/payphone/config/', { credentials: 'include' })
      .then(r => r.json())
      .then(setCfg)
      .catch(() => setCfg(null));
  }, []);

  useEffect(() => {
    if (!cfg || !txId) return;

    const payload = {
      clientTransactionId: txId,
      amount: amountInCents,
      items: items.map(it => ({
        id: it.id,
        name: it.name,
        quantity: it.quantity,
        price: Number(it.price_with_iva ?? it.price ?? 0),
        brand: it.brand || "",
        reference: it.code || it.reference || ""
      }))
    };

    fetch('/ecommerce/api/payphone/init/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': getCSRFToken()
      },
      credentials: 'include',
      body: JSON.stringify(payload)
    });
  }, [cfg, txId, amountInCents, items]);

  useEffect(() => {
    if (!iframeRef.current || !cfg) return;

    const doc = iframeRef.current.contentDocument;

    doc.open();
    doc.write(`
      <html>
      <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="stylesheet" href="https://cdn.payphonetodoesposible.com/box/v1.1/payphone-payment-box.css">
        <script type="module" src="https://cdn.payphonetodoesposible.com/box/v1.1/payphone-payment-box.js"></script>
        <style>
          html,body{margin:0;padding:0}
          #msg{font-size:1.2rem;text-align:center;padding:1rem;font-weight:bold;}
        </style>
      </head>
      <body>
        <div id="pp-inner"></div>
        <div id="msg"></div>

        <script type="module">
          try {
            const box = new window.PPaymentButtonBox({
              token: "${cfg.token}",
              storeId: "${cfg.storeId}",
              clientTransactionId: "${txId}",
              amount: ${amountInCents},
              amountWithoutTax: ${amountInCents},
              tax: 0,
              service: 0,
              tip: 0,
              currency: "${cfg.currency}",
              reference: "${txId}",
              lang: "es",
              timeZone: ${cfg.timeZone}
            });

            box.render("pp-inner");

            window.addEventListener("message", (event) => {
              if (!event.data) return;
              const m = document.getElementById("msg");

              if (event.data.type === "PAYPHONE_RESULT") {
                if (event.data.status === "completed") {
                  m.style.color = "green";
                  m.innerText = "Pago procesado correctamente.";
                } else {
                  m.style.color = "red";
                  m.innerText = "Pago rechazado.";
                }
              }
            });

          } catch (err) {
            const m = document.getElementById("msg");
            m.style.color = "red";
            m.innerText = "Error cargando PayPhone.";
          }
        </script>
      </body>
      </html>
    `);
    doc.close();
  }, [cfg, txId, amountInCents]);

  return (
    <iframe
      id="pp-iframe"
      ref={iframeRef}
      srcDoc="<html><body></body></html>"
      style={{ width: '100%', border: 'none', minHeight: '520px' }}
    />
  );
};

export default PayphoneBox;
